// removed by extract-text-webpack-plugin
module.exports = {"Icon":"src-components-topics----icon-module---Icon---9Bzo0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/topics/icon.module.scss
// module id = 437
// module chunks = 35783957827783